module.exports = "/virtual-football-league/img/amblems/right/logos/Manchester.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/Manchester.png
// module id = 2213
// module chunks = 4